module.exports = __webpack_public_path__ + "img/payout.c117d7af.svg";